(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hotspot-brand-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hotspot-brand-hero')) {
 customElements.define('hotspot-brand-hero',class extends HTMLElement {
  connectedCallback(){
   this.abort = new AbortController();
   const opts={signal:this.abort.signal};
   this.slides=[...this.querySelectorAll('[data-slide]')];
   this.dots=[...this.querySelectorAll('[data-go]')];
   this.index=0;
   this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
   this.hover=false; this.focused=false; this.visible=true;
   this.pauseButton=this.querySelector('[data-pause]');
   this.querySelector('.hs-brand-hero__controls').hidden=this.slides.length<2;
   this.drawPause=()=>{
    this.pauseButton.setAttribute('aria-label',this.paused?this.pauseButton.dataset.labelPlay:this.pauseButton.dataset.labelPause);
    this.pauseButton.firstElementChild.textContent=this.paused?'▶':'Ⅱ';
   };
   this.schedule=()=>{
    clearTimeout(this.timer);
    if(this.paused||this.hover||this.focused||!this.visible||document.hidden||this.slides.length<2) return;
    this.timer=setTimeout(()=>this.show(this.index+1),Number(this.dataset.delay)||5000);
   };
   this.show=(index)=>{
    this.index=(index+this.slides.length)%this.slides.length;
    this.slides.forEach((slide,i)=>{
     const active=i===this.index;slide.classList.toggle('is-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));
     if(active)this.dots[i].setAttribute('aria-current','true');else this.dots[i].removeAttribute('aria-current');
    });this.schedule();
   };
   this.addEventListener('click',e=>{
    const b=e.target.closest('button');if(!b)return;
    if(b.hasAttribute('data-go'))this.show(Number(b.dataset.go));
    if(b.hasAttribute('data-prev'))this.show(this.index-1);
    if(b.hasAttribute('data-next'))this.show(this.index+1);
    if(b.hasAttribute('data-pause')){this.paused=!this.paused;this.drawPause();this.schedule();}
   },opts);
   this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hover=true;this.schedule();}},opts);
   this.addEventListener('pointerleave',()=>{this.hover=false;this.schedule();},opts);
   this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},opts);
   this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget)){this.focused=false;this.schedule();}},opts);
   document.addEventListener('visibilitychange',this.schedule,opts);
   let start=null;
   const stage=this.querySelector('.hs-brand-hero__stage');
   stage.addEventListener('touchstart',e=>{start={x:e.touches[0].clientX,y:e.touches[0].clientY};},{...opts,passive:true});
   stage.addEventListener('touchend',e=>{
    if(!start)return;
    const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;
    if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))this.show(this.index+(dx<0?1:-1));start=null;
   },{...opts,passive:true});
   this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.block===e.detail.blockId);if(i>=0){this.paused=true;this.drawPause();this.show(i);}},opts);
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();},{threshold:.15});
   this.observer.observe(this);
   this.drawPause();this.schedule();
  }
  disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-editorial-slider"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('hotspot-editorial-slider')) {
  customElements.define('hotspot-editorial-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hs-editorial__track');
      this.controls = this.querySelector('.hs-editorial__controls');
      this.toggle = this.querySelector('.hs-editorial__autoplay');
      if (!this.track || !this.controls || !this.toggle) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.cards = [...this.track.children];
      if (!this.cards.length) return;
      this.rail = document.createElement('div');
      this.rail.className = 'hs-editorial__rail';
      this.cards.forEach(card => this.rail.append(card));
      this.track.append(this.rail);
      this.copies = this.cards.map(card => {
        const copy = card.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        copy.querySelectorAll('a,button,input,[tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
        this.rail.append(copy);
        return copy;
      });
      this.track.classList.add('hs-editorial__track--continuous');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.focused = false;
      this.inView = false;
      this.distance = 0;
      this.drag = null;
      this.suppressClick = false;
      this.stop = () => {
        if (!this.animation) return;
        const duration = this.animation.effect.getTiming().duration;
        const phase = (Number(this.animation.currentTime) || 0) % duration;
        const position = phase / duration * this.distance;
        this.animation.cancel();
        this.animation = null;
        this.track.scrollLeft = position;
      };
      this.sync = () => {
        this.stop();
        const fits = this.distance <= this.track.clientWidth + 2;
        this.toggle.hidden = fits;
        this.controls.hidden = fits;
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        this.toggle.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
        this.controls.querySelectorAll('button').forEach(button => { button.disabled = false; });
        if (fits || this.paused || this.motion.matches || this.focused || this.hovered || !this.inView || document.hidden || this.drag || this.interacting) return;
        const position = this.track.scrollLeft % this.distance;
        this.track.scrollLeft = 0;
        this.animation = this.rail.animate(
          [{ transform: 'translate3d(0,0,0)' }, { transform: 'translate3d(' + (-this.distance) + 'px,0,0)' }],
          { duration: this.distance / 42 * 1000, iterations: Infinity, easing: 'linear' }
        );
        this.animation.currentTime = position / 42 * 1000;
      };
      this.measure = () => {
        this.stop();
        const width = this.track.clientWidth;
        const mobile = matchMedia('(max-width: 749px)').matches;
        const tablet = matchMedia('(max-width: 1099px)').matches;
        const cardWidth = mobile ? (width - 12) * 0.76 : tablet ? (width - 12) / 2.15 : (width - 24) / 3;
        this.rail.style.setProperty('--hs-card-width', cardWidth + 'px');
        this.distance = this.copies[0].getBoundingClientRect().left - this.cards[0].getBoundingClientRect().left;
        this.sync();
      };
      this.rest = () => {
        this.interacting = true;
        clearTimeout(this.resumeTimer);
        this.sync();
        this.resumeTimer = setTimeout(() => { this.interacting = false; this.sync(); }, 1200);
      };
      this.track.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, options);
      this.track.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { this.hovered = false; this.sync(); } }, options);
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      this.addEventListener('focusin', event => {
        this.focused = event.target !== this.toggle && event.target.matches(':focus-visible');
        this.sync();
      }, options);
      this.addEventListener('focusout', event => { this.focused = !!event.relatedTarget && event.relatedTarget !== this.toggle && this.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible'); this.sync(); }, options);
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-step]');
        if (!button || !this.distance) return;
        this.rest();
        const width = this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap);
        let start = this.track.scrollLeft % this.distance;
        if (Number(button.dataset.step) < 0 && start < width) start += this.distance;
        this.track.scrollLeft = start;
        this.track.scrollBy({ left: width * Number(button.dataset.step), behavior: this.motion.matches ? 'instant' : 'smooth' });
      }, options);
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse') { this.touching = true; this.interacting = true; clearTimeout(this.resumeTimer); this.sync(); return; }
        if (event.button !== 0) return;
        this.suppressClick = false;
        this.interacting = true;
        clearTimeout(this.resumeTimer);
        this.sync();
        this.drag = { x: event.clientX, scroll: this.track.scrollLeft };
      }, options);
      window.addEventListener('pointermove', event => {
        if (!this.drag) return;
        const delta = event.clientX - this.drag.x;
        if (Math.abs(delta) > 6) {
          this.suppressClick = true;
          this.track.classList.add('is-dragging');
          this.track.scrollLeft = this.drag.scroll - delta;
        }
      }, options);
      const finish = () => { if (!this.drag && !this.touching) return; this.drag = null; this.touching = false; this.track.classList.remove('is-dragging'); this.rest(); };
      window.addEventListener('pointerup', finish, options);
      window.addEventListener('pointercancel', finish, options);
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('click', event => {
        if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); this.suppressClick = false; }
      }, { ...options, capture: true });
      this.track.addEventListener('wheel', this.rest, { ...options, passive: true });
      this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.sync(); }, options);
      document.addEventListener('visibilitychange', this.sync, options);
      this.visibilityObserver = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.sync(); }, { threshold: 0.15 });
      this.visibilityObserver.observe(this);
      this.resizeObserver = new ResizeObserver(this.measure);
      this.resizeObserver.observe(this.track);
      this.measure();
    }
    disconnectedCallback() {
      clearTimeout(this.resumeTimer);
      this.stop?.();
      this.controller?.abort();
      this.visibilityObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.copies?.forEach(copy => copy.remove());
      this.cards?.forEach(card => this.track.append(card));
      this.rail?.remove();
      this.track?.classList.remove('hs-editorial__track--continuous');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-legal-links"] && !Shopify.designMode) return;
  try {
    
function initHotspotLegal() {
  document.querySelectorAll('[data-hs-legal]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dialog = root.querySelector('[data-hs-cookie-dialog]');
    const fields = root.querySelector('[data-hs-cookie-fields]');
    const status = root.querySelector('[data-hs-cookie-status]');
    const opener = root.querySelector('[data-hs-cookie-open]');
    const names = ['preferences', 'analytics', 'marketing'];
    let api;
    const fail = () => { status.textContent = status.dataset.error; fields.disabled = true; };
    opener.addEventListener('click', () => {
      status.textContent = status.dataset.loading;
      fields.disabled = true;
      dialog.showModal();
      const loaded = error => {
        if (error || !window.Shopify?.customerPrivacy) { fail(); return; }
        api = window.Shopify.customerPrivacy;
        const current = api.currentVisitorConsent();
        names.forEach(name => { fields.querySelector('input[name="' + name + '"]').checked = current[name] === 'yes'; });
        fields.disabled = false;
        status.textContent = '';
      };
      if (window.Shopify?.customerPrivacy) loaded();
      else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], loaded);
      else fail();
    });
    const close = () => { dialog.close(); opener.focus(); };
    root.querySelector('[data-hs-cookie-close]').addEventListener('click', close);
    const save = reject => {
      if (!api) { fail(); return; }
      fields.disabled = true;
      const selection = {};
      names.forEach(name => { selection[name] = !reject && fields.querySelector('input[name="' + name + '"]').checked; });
      try {
        api.setTrackingConsent(selection, result => {
          if (result?.error) { fail(); return; }
          names.forEach(name => { fields.querySelector('input[name="' + name + '"]').checked = selection[name]; });
          fields.disabled = false;
          status.textContent = status.dataset.saved;
        });
      } catch { fail(); }
    };
    root.querySelector('[data-hs-cookie-save]').addEventListener('click', () => save(false));
    root.querySelector('[data-hs-cookie-reject]').addEventListener('click', () => save(true));
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHotspotLegal);
else initHotspotLegal();
document.addEventListener('shopify:section:load', initHotspotLegal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-purelei-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hotspot-purelei-slider')) {
  customElements.define('hotspot-purelei-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hs-purelei__track');
      this.controls = this.querySelector('.hs-purelei__controls');
      if (!this.track || !this.controls) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.update = () => {
        const cards = [...this.track.children];
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = this.track.scrollLeft;
        this.controls.hidden = max < 2;
        this.controls.querySelector('[data-step="-1"]').disabled = position <= 2;
        this.controls.querySelector('[data-step="1"]').disabled = position >= max - 2;
        const width = cards[0]?.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        const index = Math.min(cards.length, Math.round(position / width) + 1);
        this.controls.querySelector('.hs-purelei__count').textContent = index + ' / ' + cards.length;
      };
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-step]');
        if (!button || button.disabled) return;
        const card = this.track.firstElementChild;
        const width = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        this.track.scrollBy({ left: width * Number(button.dataset.step), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      let drag = null;
      let suppressClick = false;
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        suppressClick = false;
        drag = { x: event.clientX, scroll: this.track.scrollLeft };
      }, options);
      window.addEventListener('pointermove', event => {
        if (!drag) return;
        const delta = event.clientX - drag.x;
        if (Math.abs(delta) > 6) {
          suppressClick = true;
          this.track.classList.add('is-dragging');
          this.track.scrollLeft = drag.scroll - delta;
        }
      }, options);
      const finishDrag = () => {
        drag = null;
        this.track.classList.remove('is-dragging');
      };
      window.addEventListener('pointerup', finishDrag, options);
      window.addEventListener('pointercancel', finishDrag, options);
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('click', event => {
        if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; }
      }, { ...options, capture: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-recently-viewed"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hotspot-recent')) {
  customElements.define('hotspot-recent', class extends HTMLElement {
    async connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.hs-recent__track');
      const buttons = this.querySelector('.hs-recent__buttons');
      const sync = () => {
        const max = track.scrollWidth - track.clientWidth;
        buttons.hidden = max < 2;
        buttons.querySelector('[data-step="-1"]').disabled = track.scrollLeft <= 2;
        buttons.querySelector('[data-step="1"]').disabled = track.scrollLeft >= max - 2;
      };
      buttons.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || button.disabled || !track.firstElementChild) return;
        const step = track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({left:Number(button.dataset.step) * step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }, {signal});
      track.addEventListener('scroll', sync, {signal,passive:true});
      this.resize = new ResizeObserver(sync);
      this.resize.observe(track);
      track.scrollLeft = 0;
      sync();
      let history = [];
      const key = 'hotspot_recent_v1';
      try {
        const saved = JSON.parse(sessionStorage.getItem(key) || '[]');
        if (Array.isArray(saved)) history = saved.filter(v => typeof v === 'string' && /^[a-z0-9-]+$/.test(v)).slice(0,12);
      } catch {}
      const current = this.dataset.current;
      const previous = [...new Set(history)].filter(handle => handle !== current);
      if (current) {
        try { sessionStorage.setItem(key, JSON.stringify([current,...previous].slice(0,12))); } catch {}
      }
      if (!previous.length) return;
      const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
      const results = await Promise.allSettled(previous.map(async handle => {
        const url = new URL(root + 'products/' + encodeURIComponent(handle), location.origin);
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, {signal});
        if (!response.ok) return null;
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        return document.querySelector('template[data-recent-card]')?.content.firstElementChild || null;
      }));
      if (signal.aborted || !this.isConnected) return;
      const cards = results.filter(r=>r.status==='fulfilled' && r.value).map(r=>r.value);
      if (!cards.length) return;
      track.replaceChildren(...cards);
      this.querySelector('.hs-recent__notice').hidden = true;
      this.hidden = false;
      sync();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-withdrawal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hotspot-withdrawal')) {
    customElements.define('hotspot-withdrawal', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('form');
        const entry = this.querySelector('[data-entry]');
        const summary = this.querySelector('[data-summary]');
        const scope = form.elements.scope;
        form.addEventListener('submit', event => event.preventDefault());
        scope.addEventListener('change', () => {
          this.querySelector('[data-items]').hidden = scope.value !== 'part';
          form.elements.items.required = scope.value === 'part';
        });
        this.querySelector('[data-review]').addEventListener('click', () => {
          if (!form.reportValidity()) return;
          for (const key of ['customer', 'email', 'order']) {
            this.querySelector('[data-value="' + key + '"]').textContent = form.elements[key].value;
          }
          this.querySelector('[data-value="scope"]').textContent = scope.value === 'all' ? scope.options[0].textContent : form.elements.items.value;
          entry.hidden = true;
          summary.hidden = false;
          this.querySelector('[data-back]').focus();
        });
        this.querySelector('[data-back]').addEventListener('click', () => {
          summary.hidden = true;
          entry.hidden = false;
          form.elements.customer.focus();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
